<template lang="html">
  <button :aria-label="$slots.default[0].text" class="prt-autocomplete-bubble">
    <slot />
  </button>
</template>

<script>
export default {
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-autocomplete-bubble
    height: 48px
    width: calc(100% - 32px)
    max-width: 504px
    background-color: white
    color: inherit
    box-shadow: 0 2px 4px black-12
    border: none
    border-radius: (@height / 2)px
    outline: none
    cursor: pointer
    -webkit-tap-highlight-color: transparent
    font-family: inherit
    font-size: inherit
    font-weight: normal
    margin-bottom: 8px
    transition: background-color 200ms ease, color 200ms ease

    &:active
      background-color: positive
      color: white
      transform: translateY(2px)
</style>
